import { createStore, combineReducers } from 'redux'
import { configure } from '../api'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import { selectedCurrency, setCurrency } from '../actions/main-actions'
import {
  currencyDirective,
  toggleDestinations,
  hideMobileAppPromotion,
} from '../directives'
import ErrorHandler from '../components/ErrorHandler'

// import * as fx from '../libs/money'
import { getLanguage, getTranslations, getCoordinates } from 'utils'
import { toast } from 'react-toastify'
import 'babel-polyfill'
import 'whatwg-fetch'
import 'react-toastify/dist/ReactToastify.css'

import '@formatjs/intl-getcanonicallocales/polyfill'
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'
import 'finally-polyfill'

import HeroSearch from '../components/homepage/Hero'
import IndividualBooking from '../components/footer/IndividualBooking'
import Exploration from '../components/adventures/Exploration'
import AndroidBanner from '../components/helpers/AndroidBanner'
import UserLocationTitle from '../components/adventures/UserLocationTitle'
import { createRoot } from 'react-dom/client'

if(process.env.SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.SENTRY_KEY,
    ignoreErrors: [
      'AbortError',
      'UnhandledRejection',
      'Unexpected token o in JSON at position 1',
      'Anonymous function(/gtm.js)',
      "undefined is not an object (evaluating 'd.appendChild')",
      'chrome-extension',
      'gtm',
      'Illegal invocation',
      "Can't find variable: setIOSParameters",
      '(app-modern)',
      'd is undefined',
    ],
  })
}

let store = createStore(
  combineReducers({
    selectedCurrency,
  }),
)

let language = getLanguage()
let messages = {}
toast.configure()

window.store = store
configure(store)

if(language !== 'en') {
  getTranslations(language, renderApp)
} else {
  renderApp()
}

function renderApp(translatedStrings) {
  if(translatedStrings) {
    messages = translatedStrings
  }
  renderElement('homepage-hero-search', HeroSearch, {
    searchLaUrl: window.searchLaUrl,
  })
  getCoordinates(
    (coords) => renderComponentsWithCoordinates(coords),
    renderComponentsWithCoordinates,
  )
  renderElement('email-us', IndividualBooking)
  renderElement('android-banner', AndroidBanner)
  toggleDestinations()
  hideMobileAppPromotion(true)
  currencyDirective(function(currency) {
    store.dispatch(setCurrency(currency))
  })
}

function renderComponentsWithCoordinates(coords) {
  renderElement('location-title', UserLocationTitle, {
    title: window.currentLocationTitle,
    coords,
  })
  renderElement('exploration', Exploration, { coords })
}

function renderElement(elem, ComponentToRender, props) {
  let element
  if(typeof elem === 'string') {
    element = document.getElementById(elem)
  } else {
    element = elem
  }

  if(element) {
    const root = createRoot(element)
    root.render(
      <IntlProvider
        locale={language === 'ach' ? 'en' : language}
        messages={messages}
        textComponent='span'
      >
        <Provider store={store}>
          <ErrorHandler>
            <ComponentToRender {...props} />
          </ErrorHandler>
        </Provider>
      </IntlProvider>,
    )
  }
}
